<template>
    <sub-page :fullPage="true" class="student-detail-wrap">
        <div class="student-book-detail">
            <el-form class="book-form" :model="formSearch" :inline="true" size="mini">
                <select-multiple :nameArrays="selectNames"
                                v-on:getTrainTypeVal="getTrainTypeVal"
                                v-on:getExamFormVal="getExamFormVal"
                                v-on:getProjectTypeVal="getProjectTypeVal"
                                v-on:getYearTimeVal="getYearTimeVal"
                                 v-on:getLedgerOriginVal="getLedgerOriginVal">
                </select-multiple>
                <el-form-item label="实施时间">
                    <el-date-picker
                        v-model="formSearch.startTime"
                        type="date"
                        :placeholder="$t('tip.startTime')"
                        :picker-options="pickerOptions1"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <span> {{$t('c.to')}} </span>
                    <el-date-picker
                        v-model="formSearch.endTime"
                        type="date"
                        :placeholder="$t('tip.endTime')"
                        :picker-options="pickerOptions2"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  @click="getTraineeBookDetail(1)" round>{{$t('c.query')}}</el-button>
                </el-form-item>
            </el-form>

            <div class="page-table">
                <data-tables class="form-table"
                            ref="trainTable"
                            :data="tableData"
                            :table-props="tableProps"
                            :current-page.sync="currentPage"
                            :page-size="20"
                            :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                            @selection-change="handleSelectionChange"
                >
                    <!-- column checkbox -->
                <el-table-column label="#" type="index" width="40" align="center">
                    </el-table-column>
                    <!-- column title -->
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                                    :width="title.width" :min-width="title.minWidth"
                                    align="center"
                                    show-overflow-tooltip
                                    :sortable="title.sortable">
                    </el-table-column>

                    <!-- column buttons -->
                    <el-table-column :label="$t('c.operation')" align="center" width="150px">
                        <div class="btn-cell" slot-scope="scope">
                            <i class="nucfont inuc-preview"
                            :title="$t('c.view')"
                            @click="viewStandingBook(scope.row)"></i>
                        </div>
                    </el-table-column>
                </data-tables>
            </div>
        </div>

        <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOutUp">
            <router-view @onClose="getTraineeBookDetail"></router-view>
        </transition>
    </sub-page>
</template>

<script>
    import api from '@/api';
    import SubPage from '@/components/Subpage.vue'
    import selectMultiple from '@/components/Selectmultiple.vue';
    export default {
        //props: ['userId'],
        components: {
            SubPage,selectMultiple
        },
        data() {
            return {
                //搜索条件相关
                formSearch: {
                    types: [],
                    projectTypes: [],
                    forms: [],
                    years: [],
                    startTime: '',
                    endTime: ''
                },
                tableData: [],
                tableProps: {
                    border: true,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "auto",
                },
                currentPage: 1,
                titles: [
                    {
                        prop: 'standingBookName',
                        label: this.$t('train.name'),
                        minWidth: '180px'
                    },
                    {
                        prop: 'typeName',
                        label: this.$t('train.type')
                    }, {
                        prop: 'projectTypeName',
                        label: '项目类别'
                    }, {
                        prop: 'formName',
                        label: this.$t('c.examType')
                    },{
                        prop: 'originName',
                        label: '来源'
                    }, {
                        prop: 'trainer',
                        label: '授课人员',
                        sortable: 'custom'
                    }, {
                        prop: 'hours',
                        label: '学时',
                        sortable: 'custom'
                    },{
                        prop: 'score',
                        label: '学分',
                        sortable: 'custom'
                    }, {
                        prop: 'duration',
                        label: '实施时间',
                        width: '190px',
                        sortable: 'custom'
                    },
                ],
                selectNames: [{
                    key: "trainType",
                },{
                    key: "examForm",
                }, {
                    key: "projectType",
                }, {
                    key: "yearTime",
                }, {
                    key: 'ledgerOrigin',
                }],
                selectPlanId: [],
                // userId:''
            }
        },
        mounted(){
            this.userId = this.$route.params['userId']
            this.getTraineeBookDetail();
        },
        created() {

        },
        computed: {
            pickerOptions1() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.endTime) return false;
                        return time.getTime() > new Date(that.formSearch.endTime).getTime()
                    },
                }
            },
            pickerOptions2() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.startTime) return false;
                        return time.getTime() < new Date(that.formSearch.startTime).getTime()
                    },
                }
            },
        },
        methods: {
            getTraineeBookDetail(page) {
                if(page) this.currentPage = page;
                let queryData = {...this.formSearch};

                ['types', 'forms', 'projectTypes','years'].forEach(v => {
                    if (this.formSearch[v].includes(0)) {
                        delete queryData[v];
                    }
                });
                api.getTraineeBook(this.userId, queryData).then(res => {
                    let data = res.package;

                    for (let i = 0; i < data.length; i++) {
                        data[i].duration = data[i].startTime.substring(0, 10) + " — "
                            + (data[i].endTime && data[i].endTime.substring(0, 10) || '');
                        data[i].prePublishTime = data[i].prePublishTime?data[i].prePublishTime.substring(0, 16):'-';
                    }

                    this.tableData = data;
                })
            },
            //搜索赋值
            getTrainTypeVal(data) {
                this.formSearch.types = data;
            },
            getExamFormVal(data) {
                this.formSearch.forms = data;
            },
            getProjectTypeVal(data) {
                this.formSearch.projectTypes = data;
            },
            getYearTimeVal(data) {
                this.formSearch.years = data;
            },
            getLedgerOriginVal(data) {
                this.formSearch.origins = data;
            },
            //查看台账
            viewStandingBook(data) {
                this.$router.push({name: 'studentLedgerDetail', params: {ledgerId: data.standingBookId}})
            },
        },
        watch: {
            // fix: 页面定位问题、丢失参数的问题
            $route(to, from) {
                if (from.name === 'studentLedgerDetail') {
                    this.$nextTick(() => {
                        $('.app-main-inner').css({
                            overflowY: 'hidden'
                        });
                    })
                    if (to.params.userId === ':userId') {
                        let userId = from.params.userId
                        this.$router.replace({name: 'studentDetail', params: {userId}})
                    }
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';
    .student-book-detail {
        height: 100%;
        // display: flex;
        border: 1px solid #ebebed;
        .book-form{
            padding-top: 20px;
            padding-left:25px
        }
    }
    .form-table {
        display: flex;
        flex: 1;
        flex-direction: column;
        // height: 80%;
    }
</style>
<style lang="scss">
    .student-detail-wrap{
        .page-query{
            box-shadow: none;
            padding-top: 18px;
            padding-bottom: 0;
            margin-bottom: 0;
        }
        .page-table{
            box-shadow: none;
            height: 81%;
        }
        .el-select-dropdown__item {
           max-width: 250px;
        }
    }
</style>
